<template>
  <div id="pageFeedback">
    <v-container grid-list-md fluid>
      <v-card :flat="this.inDialog">
        <v-card-text>
          <v-layout row wrap justify-center>
            <v-flex md6 xs12>
              <div v-if="this.romaneio">
                <v-alert
                  border="left"
                  colored-border
                  color="deep-purple accent-4"
                  elevation="2"
                >
                  {{ this.romaneio }}
                </v-alert>
              </div>

              <v-layout row wrap>
                <v-flex xs12>
                  <h3>O que você acha do aplicativo?</h3>
                  <hr />
                  <br />
                  <div class="icons text-center">
                    <v-icon
                      @click="setRate(1)"
                      v-bind:class="[
                        model.rate == 1 ? 'active' : '',
                        'icon icon-1'
                      ]"
                      >mood_bad</v-icon
                    >
                    <v-icon
                      @click="setRate(2)"
                      v-bind:class="[
                        model.rate == 2 ? 'active' : '',
                        'icon icon-2'
                      ]"
                      >sentiment_very_dissatisfied</v-icon
                    >
                    <v-icon
                      @click="setRate(3)"
                      v-bind:class="[
                        model.rate == 3 ? 'active' : '',
                        'icon icon-3'
                      ]"
                      >sentiment_dissatisfied</v-icon
                    >
                    <v-icon
                      @click="setRate(4)"
                      v-bind:class="[
                        model.rate == 4 ? 'active' : '',
                        'icon icon-4'
                      ]"
                      >sentiment_satisfied</v-icon
                    >
                    <v-icon
                      @click="setRate(5)"
                      v-bind:class="[
                        model.rate == 5 ? 'active' : '',
                        'icon icon-5'
                      ]"
                      >sentiment_very_satisfied</v-icon
                    >
                  </div>
                </v-flex>
                <br />
                <v-flex xs12>
                  <h3>Conte um pouco mais</h3>
                  <hr />
                  <br />
                  <v-select
                    v-model="model.type"
                    :items="types"
                    item-text="text"
                    item-value="value"
                    label="Selecione o tipo de feedback"
                    outlined
                  ></v-select>

                  <v-textarea
                    v-model="model.comment"
                    outlined
                    label="Deixe seu comentário"
                  ></v-textarea>
                </v-flex>
                <v-flex xs12>
                  <v-alert type="error" v-if="hasError">
                    Por favor selecione uma opção do "O que você acha do
                    aplicativo?"
                  </v-alert>
                  <v-btn
                    :loading="loading"
                    @click="saveFeedback"
                    block
                    color="success"
                    >Enviar</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-container>

    <v-dialog v-model="dialog" width="500" @click:outside="goHome">
      <v-card>
        <v-card-title class="headline green white--text" primary-title>
          Feedback enviado com sucesso!
        </v-card-title>

        <v-card-text>
          <br />
          <p class="title">
            Obrigado pela sua avalição, ela é muito importante para nós.
          </p>
          <p class="title">
            Vamos analizar o seu feedback e responderamos o mais breve possível.
          </p>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="goHome">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import appApi from "../../plugins/api";

export default {
  props: {
    inDialog: Boolean,
    trackId: String
  },
  components: {},
  data: function() {
    return {
      prevRoute: null,
      model: {
        rate: null,
        type: null,
        comment: "",
        track_id: null
      },
      romaneio: "",
      hasError: false,
      loading: false,
      dialog: false,
      backPrevious: false,
      types: [
        { text: "Sugestão", value: 1 },
        { text: "Elogio", value: 2 },
        { text: "Reclamação", value: 3 }
      ]
    };
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from;
    });
  },

  mounted: function() {
    window.scrollTo(0, 0);
    if (this.$route.query.romaneio) {
      this.romaneio = "Romaneio: " + this.$route.query.romaneio + "\n";
      this.model.track_id = this.$route.query.romaneio;

      this.backPrevious = true;
    }

    console.log(this.trackId);

    if (this.trackId) {
      this.romaneio = "Romaneio: " + this.trackId + "\n";
      this.model.track_id = this.trackId;
    }
  },

  watch: {
    prevRoute: function(val) {
      if (
        this.prevRoute &&
        this.prevRoute.name == "Romaneio" &&
        !this.backPrevious
      ) {
        this.romaneio = "Romaneio: " + this.prevRoute.params.id + "\n";
        this.model.track_id = this.$route.query.romaneio;
        this.backPrevious = true;
      }
    }
  },

  methods: {
    saveFeedback() {
      this.hasError = false;
      this.loading = true;
      if (this.model.rate == null) {
        this.hasError = true;
        this.loading = false;
        return;
      }
      appApi.postFeedback(this.model).then(result => {
        this.loading = false;
        this.dialog = true;
      });
    },

    setRate(rate) {
      this.model.rate = rate;
    },

    goHome() {
      if (this.inDialog) {
        this.$emit("close", false);

        this.model = {
          ...this.model,
          rate: null,
          type: null,
          comment: ""
        };

        return;
      }

      if (this.backPrevious) {
        this.$router.go(-1);
      }

      location.reload();
    }
  }
};
</script>
<style scoped lang="css">
#pageFeedback {
  position: relative;
}

#pageFeedback .icons .icon {
  font-size: 60px;
  cursor: pointer;
}

#pageFeedback .icon.icon-1.active,
#pageFeedback .icon.icon-1:hover {
  color: #f44336;
}

#pageFeedback .icon.icon-2.active,
#pageFeedback .icon.icon-2:hover {
  color: #ef9a9a;
}

#pageFeedback .icon.icon-3.active,
#pageFeedback .icon.icon-3:hover {
  color: #ff9800;
}

#pageFeedback .icon.icon-4.active,
#pageFeedback .icon.icon-4:hover {
  color: #2196f3;
}

#pageFeedback .icon.icon-5.active,
#pageFeedback .icon.icon-5:hover {
  color: #4caf50;
}
</style>
